import { render, staticRenderFns } from "./DashboardCardsPendenciasTotalizadores.vue?vue&type=template&id=30b63c7f"
import script from "./DashboardCardsPendenciasTotalizadores.vue?vue&type=script&lang=js"
export * from "./DashboardCardsPendenciasTotalizadores.vue?vue&type=script&lang=js"
import style0 from "./DashboardCardsPendenciasTotalizadores.vue?vue&type=style&index=0&id=30b63c7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports